export default function ({ app }) {
  app.nuxt.error = () => {}
}
